export type TravelRequestStatus = 'pending' | 'assigned' | 'completed' | 'rejected' | 'expired';

export interface IGuest {
    id: number;
    age: number;
}

export interface ITravelRequest {
    id: string;
    user_id?: string;
    destinations?: string[];
    departure_point?: string;
    needs_transportation?: boolean;
    total_guests?: number;
    guests_data?: unknown;
    travel_dates_flexible?: boolean;
    travel_start_date?: string;
    travel_end_date?: string;
    budget_min?: number;
    budget_max?: number;
    budget_flexible?: boolean;
    interests?: string[];
    additional_notes?: string;
    contact_first_name: string;
    contact_last_name: string;
    contact_email: string;
    contact_phone: string;
    status: string;
    assigned_designer_id?: string;
    travel_designer_preference?: string;
    created_at?: string;
    updated_at?: string;

    users_detail?: {
        assigned: any;
        preferred: any;
    };
}

export class TravelRequest implements ITravelRequest {
    id: string;
    user_id: string;
    destinations: string[];
    departure_point: string;
    needs_transportation: boolean;
    total_guests: number;
    guests_data: IGuest[];
    travel_dates_flexible: boolean;
    travel_start_date: string;
    travel_end_date: string;
    budget_min: number;
    budget_max: number;
    budget_flexible: boolean;
    interests: string[];
    additional_notes: string;
    contact_first_name: string;
    contact_last_name: string;
    contact_email: string;
    contact_phone: string;
    status: TravelRequestStatus;
    assigned_designer_id: string | null;
    travel_designer_preference: string | null;
    created_at: string;
    updated_at: string;

    users_detail?: {
        assigned: any;
        preferred: any;
    };

    get isAssigned(): boolean {
        return this.assigned_designer_id !== null && this.status === 'assigned';
    }

    get isPending(): boolean {
        return this.status === 'pending';
    }

    get isCompleted(): boolean {
        return this.status === 'completed';
    }

    get isRejected(): boolean {
        return this.status === 'rejected';
    }

    get isExpired(): boolean {
        return this.status === 'expired';
    }

    get workingOn(): boolean {
        return this.status === 'assigned' || this.status === 'completed';
    }

    constructor(data: ITravelRequest) {
        this.id = data.id;
        this.user_id = data.user_id;
        this.destinations = data.destinations || [];
        this.departure_point = data.departure_point || '';
        this.needs_transportation = data.needs_transportation || false;
        this.total_guests = data.total_guests || 0;
        this.guests_data = Array.isArray(data.guests_data) ? data.guests_data as unknown as IGuest[] : [];
        this.travel_dates_flexible = data.travel_dates_flexible || false;
        this.travel_start_date = data.travel_start_date || '';
        this.travel_end_date = data.travel_end_date || '';
        this.budget_min = data.budget_min || 0;
        this.budget_max = data.budget_max || 0;
        this.budget_flexible = data.budget_flexible || false;
        this.interests = data.interests || [];
        this.additional_notes = data.additional_notes || '';
        this.contact_first_name = data.contact_first_name;
        this.contact_last_name = data.contact_last_name;
        this.contact_email = data.contact_email;
        this.contact_phone = data.contact_phone;
        this.status = data.status as TravelRequestStatus;
        this.assigned_designer_id = data.assigned_designer_id || null;
        this.travel_designer_preference = data.travel_designer_preference || null;
        this.created_at = data.created_at;
        this.updated_at = data.updated_at;
        this.users_detail = data.users_detail;
    }

}
